import { clsx } from 'clsx'
import type { ComponentChildren } from 'preact'
import type { JSXInternal } from 'preact/src/jsx'

type Props = {
	children: ComponentChildren
	className?: string
	id: string
	onClick?: JSXInternal.MouseEventHandler<HTMLDivElement>
}

const Card = ({ children, className, id, onClick }: Props) => (
	<div
		aria-hidden='true'
		class={clsx('cursor-pointer rounded-md bg-black-800 p-5', className)}
		id={id}
		onClick={onClick}
	>
		{children}
	</div>
)

export { Card }
